export default "__VITE_ASSET__d0600c11__"